// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___18a1f0353172513dbc2","cls2":"FeedbackModal-cls2__dd4fd42be15b1128eb74 FeedbackModal-cls1___18a1f0353172513dbc2"};